import _ from "lodash";
export default class Responsabile {
    constructor(arg = undefined) {
      if (arg != undefined) {
        const campi = this.setControlli();
        campi.forEach((c) => {
          if(arg[c.nome] === 'personale'){
            this[c.nome] = _.cloneDeep(arg[c.nome]);
          }else{
            this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
          }
        });
      } else {
        const campi = this.setControlli();
        campi.forEach((c) => {
          this[c.nome] = c.default_val;
        });
      }
    }
  
    // Metodo per resettare tutte i campi
    reset() {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  
    setControlli() {
      const campi = [
        { nome: "id_personale", default_val: null },
        { nome: "id_padre", default_val: null },
        { nome: "id_team", default_val: -1 },
        { nome: "nominativo", default_val: "" },
        { nome: "personale", default_val: [] },
        { nome: "validita", default_val: 1 },
      ];
      return campi;
    }
  }